import React, { useState } from 'react';
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import _ from 'lodash';

interface ISaveFilterModal {
  open: boolean;
  names: string[];
  onSave: (name: string) => void;
  onClose: () => void;
}

export default function SaveFilterModal({ open, names, onSave, onClose }: ISaveFilterModal) {
  const [selectedName, setSelectedName] = useState<string | null>(null);

  const helperText = !!_.trim(selectedName ?? '') && _.includes(names, selectedName) ? 'The existing filter with this name will be overwritten!' : undefined;

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>
        Save Filter
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ pb: 2 }}>
          Please choose under which name to save the current filter.
        </DialogContentText>

        <Autocomplete
          freeSolo
          options={names}
          onChange={(_, value) => setSelectedName(value)}
          renderInput={(params) => (
            <TextField {...params} autoFocus label="Filter Name" onChange={(event) => setSelectedName(event.target.value)} helperText={helperText} />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" disabled={_.isNull(selectedName)} onClick={() => onSave(selectedName || '')}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}